// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__X2Czz","label":"styles_label__1BzQI"};